/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiSurface = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5.917 16.816v-1.554c1.045.41 2.053.616 3.024.616.681 0 1.213-.126 1.596-.378.392-.252.588-.597.588-1.036a.996.996 0 0 0-.364-.798c-.243-.215-.695-.439-1.358-.672l-1.064-.392c-.905-.336-1.554-.728-1.946-1.176-.383-.457-.574-1.012-.574-1.666 0-.896.336-1.6 1.008-2.114.672-.522 1.587-.784 2.744-.784.485 0 .97.052 1.456.154a5.49 5.49 0 0 1 1.288.42V8.99c-.961-.401-1.871-.602-2.73-.602-1.335 0-2.002.43-2.002 1.288 0 .308.121.56.364.756.243.196.686.415 1.33.658l1.078.392c.943.346 1.6.742 1.974 1.19.383.448.574 1.027.574 1.736 0 .934-.331 1.666-.994 2.198s-1.591.798-2.786.798a8.81 8.81 0 0 1-1.19-.084 9.877 9.877 0 0 1-1.134-.196 5.02 5.02 0 0 1-.882-.308zm8.946.406v-6.034h-1.288v-.854l1.288-.49v-.602c0-1.764.85-2.646 2.548-2.646.261 0 .5.024.714.07v1.316a1.489 1.489 0 0 0-.21-.014 1.489 1.489 0 0 0-.21-.014c-.41 0-.705.098-.882.294-.168.196-.252.518-.252.966v.644h1.61v1.33h-1.61v6.034h-1.708z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiSurface as PmiSurface };
